import React, { useEffect, useState } from 'react';
import { TouchableOpacity, View } from 'react-native';

import PropTypes from 'prop-types';

import { VFText } from '@vfgroup-oneplatform/foundation/Components';

import styles from './PaginatedList.style';

const PaginatedList = ({ pageSize, data, showMoreLabel, showLessLabel, renderItem, ...props }) => {
  const minPageSize = Math.min(pageSize, data.length);
  const [numberOfShownData, setNumberOfShownData] = useState(minPageSize);

  useEffect(() => {
    setNumberOfShownData(minPageSize);
  }, [JSON.stringify(data)]);

  const onPressShowMore = () => setNumberOfShownData(num => num + pageSize);
  const onPressShowLess = () => setNumberOfShownData(pageSize);

  return (
    <View {...props}>
      <>
        {data?.slice(0, numberOfShownData)?.map(item => {
          return renderItem(item);
        })}
      </>
      {numberOfShownData < data?.length && (
        <View style={styles.showMoreContainer}>
          <TouchableOpacity onPress={onPressShowMore}>
            <VFText i18nKey={showMoreLabel} style={styles.showMoreStyle} type="tertiary" />
          </TouchableOpacity>
        </View>
      )}
      {numberOfShownData > data?.length && (
        <View style={styles.showMoreContainer}>
          <TouchableOpacity onPress={onPressShowLess}>
            <VFText i18nKey={showLessLabel} style={styles.showMoreStyle} type="tertiary" />
          </TouchableOpacity>
        </View>
      )}
    </View>
  );
};

PaginatedList.defaultProps = {
  pageSize: 8,
  showMoreLabel: 'soho_dashboard_applications_explore_show_more_title',
  showLessLabel: 'soho_business_overview_devices_tab_show_less_title',
};

PaginatedList.propTypes = {
  pageSize: PropTypes.number,
  data: PropTypes.arrayOf(PropTypes.object).isRequired,
  showMoreLabel: PropTypes.string,
  renderItem: PropTypes.func.isRequired,
  showLessLabel: PropTypes.string,
};

export default React.memo(PaginatedList);
